import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { DentalService } from '../../_service/dental.service';
import {PageEvent,MatPaginator} from '@angular/material/paginator';
import * as XLSX from 'xlsx';
import {formatDate} from '@angular/common';
@Component({
  selector: 'app-scan-report',
  templateUrl: './scan-report.component.html',
  styleUrls: ['./scan-report.component.css']
})
export class ScanReportComponent implements OnInit {

  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;

  perpage:number=10;length:number=0;pageEvent: PageEvent; pageSizeOptions = [10,25,50,100]; pageIndex:number=0;
  loading = true; loaded = false;  scanReportLists = []; maxDate = new Date();
  search:string; start_date:string=''; end_date:string=''; 
  constructor(private sharedapi:SharedService, private dentalapi:DentalService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.getTotalScanReport(0,this.perpage);
  }

  dateRangeChange(date1,date2)
  {
    if(date2.value)
    {
      this.start_date = date1.value;
      this.end_date = date2.value;
    }
  }

  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.getTotalScanReport(event.pageIndex,event.pageSize);
  }

  resetFilters()
  {
    this.search = '';
    this.clearDate();
    this.getTotalScanReport(0,10);
  }

  async getTotalScanReport(pageIndex,perpage)
  {
    this.paginator.pageIndex = pageIndex; 
    this.paginatorBottom.pageIndex = pageIndex;
    this.pageIndex = pageIndex;
    let qString = 'search='+this.search+'&date_range='+this.start_date+'-'+this.end_date;
    this.loading = true;
    this.loaded = false;
    this.scanReportLists = [];
    await this.dentalapi.scanReportLists(this.paginator.pageIndex,perpage, qString).subscribe((data:any) => {
      this.length = data.totaldata;
      this.loading = false;
      this.loaded = true;
      if(data.status)
      {
          this.scanReportLists = data.data;
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  exportScanReportList()
  {
    if(this.scanReportLists.length>0)
    {
      let data = [];
      let titles = [
        'Circle',
        'Scan Done Date',
        'Month-Year',
        'Patient Name',
        'Glamyo Patient ID',
        'Patient Contact Number',
        'Email ID',
        'Gender',
        'Address',
        'Appointment Time',
        'BD Name',
        'Scan pro',
        'App Type',
        'Scan Status',
        'Document Link',
        'Document upload date',
        'Docs Share with Lab'
      ];
      data.push(titles);
      for(let scanReport in this.scanReportLists)
      {
        let exdata = [
          this.scanReportLists[scanReport].circle_name,
          this.scanReportLists[scanReport].scan_done_date ? formatDate(this.scanReportLists[scanReport].scan_done_date*1000, 'dd-MM-yyyy', 'en-US'): '',
          this.scanReportLists[scanReport].scan_done_date ? formatDate(this.scanReportLists[scanReport].scan_done_date*1000, 'MM-yyyy', 'en-US'): '',
          this.scanReportLists[scanReport].lead_name,
          this.scanReportLists[scanReport].glamyo_patient_id,
          this.scanReportLists[scanReport].mobile,
          this.scanReportLists[scanReport].email,
          this.scanReportLists[scanReport].gender,
          this.scanReportLists[scanReport].address,
          this.scanReportLists[scanReport].appointment_datetime ? formatDate(this.scanReportLists[scanReport].appointment_datetime*1000, 'dd-MM-yyyy hh:mm a', 'en-US'): '',
          this.scanReportLists[scanReport].bd_name,
          this.scanReportLists[scanReport].pro_name,
          this.scanReportLists[scanReport].appointment_type == 2 ? "Re Scan" : "New Scan",
          this.scanReportLists[scanReport].scan_status == 1 ? "Yes" : "No",
          this.scanReportLists[scanReport].google_form_link,
          this.scanReportLists[scanReport].document_upload_date ? formatDate(this.scanReportLists[scanReport].document_upload_date*1000, 'dd-MM-yyyy', 'en-US'): '',
          this.scanReportLists[scanReport].link_send_on ? formatDate(this.scanReportLists[scanReport].link_send_on*1000, 'dd-MM-yyyy hh:mm a', 'en-US'): ''
        ];
        data.push(exdata)
      }
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
      XLSX.writeFile(wb, 'scan_report_lists_'+utc+'.xlsx');
    }else{
      this.sharedapi.presentToast('Sorry! No data found for export.');
    }
  }
}
